var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"960px"},model:{value:(_vm.isVisibleDialog),callback:function ($$v) {_vm.isVisibleDialog=$$v},expression:"isVisibleDialog"}},[(_vm.isVisibleDialog)?_c('booking-form',{attrs:{"options":_vm.options,"type":"Create"},on:{"change":_vm.change,"onclose":_vm.closeForm}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }